/**
 * @description Pack-modal industry subset (LYN-361)
 *
 * Key features:
 * - Filters existing INDUSTRY_TYPES values — no new enum / table
 * - LynxPay INDUSTRY_TYPES stays the full list
 *
 * @dependencies industryTypes
 *
 * @notes Pack onboarding only. Do not edit INDUSTRY_TYPES here.
 */

import { INDUSTRY_TYPES } from './industryTypes';

export const PACK_INDUSTRY_VALUES = [
  'automotive',
  'transportation',
  'construction',
  'general_business'
];

/**
 * @returns {{ value: string, label: string }[]}
 */
export function packIndustryTypes() {
  return PACK_INDUSTRY_VALUES
    .map((value) => INDUSTRY_TYPES.find((row) => row.value === value))
    .filter(Boolean);
}
